<!-- Pill de botón (imagen o color+ícono+texto) -->
<ng-template #pill let-b="b" let-h="h">
  @if (b.urlImagen) {
    <div class="pbtn pimg" [style.min-height.px]="h">
      <img [src]="b.urlImagen" [alt]="b.nombre || ''" />
    </div>
  } @else {
    <div class="pbtn" [style.background]="b.color || '#888'" [style.color]="ink(b.color)" [style.min-height.px]="h">
      <span class="pico">{{ ico(b.funcion) }}</span><span>{{ b.texto || b.nombre || 'Botón' }}</span>
    </div>
  }
</ng-template>

<!-- Pill solo ícono (filas chicas con label externo) -->
<ng-template #iconPill let-b="b" let-h="h">
  <div class="pbtn icononly" [style.background]="b.color" [style.color]="ink(b.color)" [style.min-height.px]="h">
    <span class="pico">{{ ico(b.funcion) }}</span>
  </div>
</ng-template>

<!-- Campos de login (mismo flow en los 3 templates) -->
<ng-template #loginFields let-bg="bg" let-fg="fg">
  <div class="fld">Teléfono</div>
  <div class="fld">Código</div>
  <div class="cta" [style.background]="bg" [style.color]="fg">Ingresar</div>
  <div class="linkbtn">Reenviar código</div>
  <div class="linkbtn">Registrarme</div>
</ng-template>

<!-- Botones principales: 1 → cuadrado grande · 2-3 → rectangulares · 4+ → chicos (scroll). Igual en todas. -->
<ng-template #principales>
  @if (botonesActuales.length === 1) {
    @if (botonesActuales[0].urlImagen) {
      <div class="bigbtn pimg"><img [src]="botonesActuales[0].urlImagen" alt="" /></div>
    } @else {
      <div class="bigbtn" [style.background]="botonesActuales[0].color" [style.color]="ink(botonesActuales[0].color)">
        <span class="pico">{{ ico(botonesActuales[0].funcion) }}</span>{{ botonesActuales[0].texto || botonesActuales[0].nombre }}
      </div>
    }
  } @else {
    @for (b of botonesActuales; track $index) {
      <ng-container *ngTemplateOutlet="pill; context: { b: b, h: alturaPrincipal(botonesActuales.length) }"></ng-container>
    }
  }
</ng-template>

<!-- Fila inferior: [REFLECTOR | (CHAT)(MÁS) | SIRENA]. Sin labels (PanicButton pelado), igual al nativo. -->
<ng-template #filaInferior let-chat="chat" let-h="h">
  @if (mostrarSirenas || (chat && mostrarChat) || hayMas) {
    <div class="fila-inf">
      <div class="fi-cell">
        @if (mostrarSirenas) { <ng-container *ngTemplateOutlet="iconPill; context: { b: reflector, h: h }"></ng-container> }
      </div>
      @if (chat && mostrarChat) {
        <div class="fi-cell"><ng-container *ngTemplateOutlet="iconPill; context: { b: chatBoton, h: h }"></ng-container></div>
      }
      @if (hayMas) {
        <div class="fi-cell"><div class="navbtn" (click)="setPagina(2)">Más</div></div>
      }
      <div class="fi-cell">
        @if (mostrarSirenas) { <ng-container *ngTemplateOutlet="iconPill; context: { b: sirena, h: h }"></ng-container> }
      </div>
    </div>
  }
</ng-template>

<!-- Fila de sub-página (pág 2): Atrás. -->
<ng-template #filaSubpagina>
  <div class="fila-inf">
    <div class="fi-cell"><div class="navbtn" (click)="setPagina(1)">Atrás</div></div>
  </div>
</ng-template>

<!-- Footer: banner `abajo` (~60% ancho, FillWidth), debajo de la fila. -->
<ng-template #footerAbajo>
  <div class="footer-banner"><img [src]="img(vm.abajo, 'abajo')" alt="abajo" /></div>
</ng-template>

<div class="preview-head">
  <span class="preview-title">Preview en vivo · nativo</span>
  <div class="seg">
    @if (!soloBotonera) {
      <button type="button" [class.on]="modo === 'login' || soloLogin" (click)="setModo('login')">Login</button>
    }
    @if (!soloLogin) {
      <button type="button" [class.on]="modo === 'botonera' || soloBotonera" (click)="setModo('botonera')">Botonera</button>
    }
  </div>
</div>

<div class="phone">
  <div
    class="screen"
    [class.has-fondo]="modo === 'botonera' || soloBotonera"
    [style.--brand]="vm.brand"
    [style.--brand-ink]="vm.brandInk"
    [style.background-image]="(modo === 'botonera' || soloBotonera) ? 'url(' + img(vm.fondo, 'fondo') + ')' : null"
  >
    @if ((modo === 'login' || soloLogin) && !soloBotonera) {
      @switch (vm.loginTemplate) {
        @case ('logo-centrado') {
          <div class="lg-logo brandbg">
            <img class="big-logo-img" [src]="img(vm.login, 'login')" alt="logo" />
            <ng-container *ngTemplateOutlet="loginFields; context: { bg: '#fff', fg: vm.brand }"></ng-container>
          </div>
        }
        @case ('hero') {
          <div class="lg-hero">
            <!-- Banda superior: color del tema + banner (login) centrado -->
            <div class="hero-band brandbg">
              <img [src]="img(vm.login, 'login')" alt="banner" />
            </div>
            <!-- Form debajo, sobre blanco -->
            <div class="form">
              <div class="card-title" [style.color]="vm.brand">Ingresar</div>
              <ng-container *ngTemplateOutlet="loginFields; context: { bg: vm.brand, fg: vm.brandInk }"></ng-container>
            </div>
          </div>
        }
        @default {
          <div class="lg-default brandbg">
            <img class="logo-top-img" [src]="img(vm.login, 'login')" alt="logo" />
            <div class="lg-card">
              <div class="card-title">Ingresar</div>
              <ng-container *ngTemplateOutlet="loginFields; context: { bg: vm.brand, fg: vm.brandInk }"></ng-container>
            </div>
          </div>
        }
      }
    } @else {
      <!-- ===================== BOTONERA ===================== -->
      @switch (vm.botoneraId) {

        @case ('banner') {
          <div class="banner-big"><img [src]="img(vm.arriba, 'arriba')" alt="banner" /></div>
          <div class="princ"><ng-container *ngTemplateOutlet="principales"></ng-container></div>
          @if (pagina === 1) {
            <ng-container *ngTemplateOutlet="filaInferior; context: { chat: true, h: 52 }"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="filaSubpagina"></ng-container>
          }
          <ng-container *ngTemplateOutlet="footerAbajo"></ng-container>
        }

        @case ('centrado') {
          <div class="banner-big sm"><img [src]="img(vm.arriba, 'arriba')" alt="banner" /></div>
          <div class="princ"><ng-container *ngTemplateOutlet="principales"></ng-container></div>
          @if (pagina === 1) {
            <ng-container *ngTemplateOutlet="filaInferior; context: { chat: false, h: 52 }"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="filaSubpagina"></ng-container>
          }
          <ng-container *ngTemplateOutlet="footerAbajo"></ng-container>
        }

        @case ('hub') {
          <div class="bn-top sm"><img [src]="img(vm.arriba, 'arriba')" alt="logo" /></div>
          <div class="princ">
            @for (b of pPrincipales; track $index) {
              <div class="menucard" [style.background]="'color-mix(in srgb, ' + (b.color || vm.brand) + ' 18%, #fff)'">
                <span class="pico">{{ ico(b.funcion) }}</span>{{ b.texto || b.nombre || 'Opción' }}
              </div>
            }
          </div>
        }

        @default {
          <!-- grid (default) -->
          <div class="bn-top"><img [src]="img(vm.arriba, 'arriba')" alt="logo" /></div>
          <div class="princ"><ng-container *ngTemplateOutlet="principales"></ng-container></div>
          @if (pagina === 1) {
            <ng-container *ngTemplateOutlet="filaInferior; context: { chat: false, h: 52 }"></ng-container>
          } @else {
            <ng-container *ngTemplateOutlet="filaSubpagina"></ng-container>
          }
          <ng-container *ngTemplateOutlet="footerAbajo"></ng-container>
        }
      }

      <!-- Barra inferior del shell: Inicio (fijo) + secciones segun modulos + Más -->
      <div class="navbar">
        <div class="navitem on"><span class="ni-ic">🏠</span><span class="ni-l">Inicio</span></div>
        @for (s of vm.navSecciones.slice(0, 3); track s.l) {
          <div class="navitem"><span class="ni-ic">{{ s.ic }}</span><span class="ni-l">{{ s.l }}</span></div>
        }
        <div class="navitem"><span class="ni-ic">☰</span><span class="ni-l">Más</span></div>
      </div>
    }
  </div>
</div>

<div class="legend">
  @if (soloBotonera) {
    botonera <code>{{ vm.botoneraId }}</code>
  } @else if (soloLogin) {
    login <code>{{ vm.loginTemplate }}</code>
  } @else {
    login <code>{{ vm.loginTemplate }}</code> · botonera <code>{{ vm.botoneraId }}</code>
  }
</div>
